export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_ROLE: 'user_role',
  USER_ID: 'user_id',
  USER_EMAIL: 'user_email',
  USERNAME: 'user_name'
}

export const clearAuth = () => {
  Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key))
  sessionStorage.clear()
}
